import Api from "./api.service";
import { decamelizeKeys } from "humps";
import { isArray, assign, pickBy, isEmpty } from "lodash";

class User {
  static addUser({ tenants, ...attrs }) {
    const params = decamelizeKeys(attrs);
    const tempAttributes = pickBy(params, item => !isArray(item));
    if (tenants && tenants.length > 1 && params.admin !== true) {
      return Promise.all(
        tenants.map(tenant => {
          const attributes = assign({}, tempAttributes);
          const relationships = isEmpty(tenants) ? {} : { tenant: { data: { type: "tenants", id: tenant } } };
          const splitEmail = attributes.email.split("@");
          attributes.email = splitEmail[0] + "+" + tenant + "@" + splitEmail[1];
          return Api.post("/api/v1/users", { data: { type: "users", attributes, relationships } });
        })
      );
    }
    const attributes = decamelizeKeys(attrs);
    const payload = { data: { type: "users", attributes } };
    if (tenants && params.admin !== true) {
      payload.data.relationships = { tenant: { data: { id: tenants[0], type: "tenants" } } };
    }
    return Api.post("/api/v1/users", payload);
  }

  static updateUser(id, { tenants, ...attrs }) {
    const attributes = decamelizeKeys(attrs);
    const payload = { data: { id: id, type: "users", attributes } };
    if (tenants) {
      payload.data.relationships = { tenant: { data: { id: tenants, type: "tenants" } } };
    }
    return Api.put(`/api/v1/users/${id}`, payload);
  }

  static getAll() {
    return Api.get(`/api/v1/users/?include=tenant`);
  }

  static get(id) {
    return Api.get(`/api/v1/users/${id}?include=tenant`);
  }

  static delete(id) {
    return Api.delete(`/api/v1/users/${id}`);
  }
}

const UserService = Object.freeze(User);
export default UserService;
